module.exports = __webpack_public_path__ + "static/media/1_pl.1e285e72.png";